import { BaseMicroAppPlugin } from './core/BaseMicroAppPlugin';
import { ConsoleLoggerPlugin } from './plugins/ConsoleLoggerPlugin';
import { IMicroAppData } from './core/types';
import { StateManagerPlugin } from './plugins/StateManagerPlugin';

export class MicroAppsMonitor {
  private static instance: MicroAppsMonitor;
  private plugins: Map<string, BaseMicroAppPlugin>;
  private enabled: boolean;

  private constructor() {
    this.plugins = new Map();
    this.enabled = true;

    // Register default plugins
    this.registerPlugin(new StateManagerPlugin());
    this.registerPlugin(new ConsoleLoggerPlugin());
  }

  static getInstance(): MicroAppsMonitor {
    if (!MicroAppsMonitor.instance) {
      MicroAppsMonitor.instance = new MicroAppsMonitor();
    }
    return MicroAppsMonitor.instance;
  }

  initialize(): void {
    // Initialize all plugins
    this.plugins.forEach(plugin => {
      if (plugin.initialize) {
        plugin.initialize();
      }
    });
  }

  registerPlugin(plugin: BaseMicroAppPlugin): void {
    this.plugins.set(plugin.getId(), plugin);
  }

  getPlugin(id: string): BaseMicroAppPlugin | undefined {
    return this.plugins.get(id);
  }

  enable(): void {
    this.enabled = true;
    this.plugins.forEach(plugin => plugin.enable());
  }

  disable(): void {
    this.enabled = false;
    this.plugins.forEach(plugin => plugin.disable());
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  onMount(data: IMicroAppData): void {
    if (!this.enabled) return;
    this.plugins.forEach(plugin => plugin.onMount?.call(plugin, data));
  }

  onUnmount(data: IMicroAppData): void {
    if (!this.enabled) return;
    this.plugins.forEach(plugin => plugin.onUnmount?.call(plugin, data));
  }
}